import { travel } from 'api';

import { Response } from 'models/response';

export type HotelAmenities = {
  code: string;
  name: string;
};

export const getAmenities = (sessionToken: string, locale: string): Promise<HotelAmenities[]> =>
  travel
    .get<Response<HotelAmenities[]>>('Hotel/Ammenities', {
      params: { sessionToken, language: locale.substring(0, 2).toUpperCase() },
    })
    .then((response) => response.data.data);
